import React from 'react'; // Add missing import statement
import moment from 'moment';
import { NumberFormat } from "../../Components/NumberFormat";
import { Link } from 'react-router-dom';
const { $ } = window;

const BalanceInquiryDetail = (state) => {
    const hideModal = () => {
        $('#modalBalanceDetail').modal('hide');
        
    }
    
    return (
        <div className="container-fluid" style={{padding: '37px'}}>
            <div className="row">
                <div className="col-md-12" style={{alignContent:'center', paddingBottom: '27px'}}>
                    <h4 style={{marginLeft:'-13px'}}>Sales Order Payment Detail</h4>
                </div>
                <div style={{position:'absolute', right: '17px', top: '17px'}}><Link style={{textDecoration: 'none'}}><h5 onClick={hideModal}>X</h5></Link></div>
            </div>
            <div><h5 style={{marginLeft:'-13px'}}>Sales Order Information</h5></div>
            <div className="row">More SO Number: {state.selectedBalanceDetails?.DocNumSO}</div>
            <div className="row">Store : [{state.selectedBalanceDetails?.withdraw_store}] {state.selectedBalanceDetails?.bplfrname} </div>
            <div className="row">Created Date: {moment(state.selectedBalanceDetails?.DocDate).format('DD MMMM YYYY HH:mm:ss')}</div>
            <div className="row">Customer Name: {state.selectedBalanceDetails?.CardName}</div>
            <div className='row'>Sales Consultant : {state.selectedBalanceDetails?.created_by_name}</div>
            <div className="row">Order Amount (IDR) : {NumberFormat(state.selectedBalanceDetails?.paid_amount)}</div>
            <div><h5 style={{marginLeft:'-13px', marginTop:'13px'}}>Payment Gateway Information</h5></div>
            <div className="row">Payment Status: {state.selectedBalanceDetails?.pg_status}</div>
            <div className="row">Transaction ID: {state.selectedBalanceDetails?.ipg_txn_id}</div>
            <div className="row">Reference ID: {state.selectedBalanceDetails?.reference_id}</div>
            <div className="row">Payment Method : {state.selectedBalanceDetails?.payment_method}</div>
            <div className="row">Payment Channel: {state.selectedBalanceDetails?.payment_channel}</div>
            {
                state.bank_code !== '' &&
                <div className="row">Bank Code: {state.selectedBalanceDetails?.bank_code}</div>
            }
            <div className="row">Payment Date: {moment(state.selectedBalanceDetails?.paid_at).format('DD MMMM YYYY HH:mm:ss')}</div>
            <div className="row">Payment Amount (IDR) : {NumberFormat(state.selectedBalanceDetails?.paid_amount)}</div>
            <div><h5 style={{marginLeft:'-13px', marginTop:'13px'}}>Withdrawal Information</h5></div>
            <div className="row">Withdrawal Status: {state.selectedBalanceDetails?.withdraw_status}</div>
            <div className="row">Withdrawal Reference: {state.selectedBalanceDetails?.withdraw_number}</div>
            <div className="row">Withdrawal Date: {moment(state.selectedBalanceDetails?.withdraw_date).format('DD MMMM YYYY HH:mm:ss')}</div>
            <div className="row">Withdrawal Bank: {state.selectedBalanceDetails?.withdraw_bank}</div>
            <div className="row">Withdrawal Account: {state.selectedBalanceDetails?.withdraw_account}</div>
            <div className="row">Withdrawal Account Name: {state.selectedBalanceDetails?.withdraw_account_name}</div>
            <div className="row">Withdrawal Amount (IDR): {NumberFormat(state.selectedBalanceDetails?.amount)}</div>
            <div className="row">Payment Gateway Fee + PPN (IDR): {NumberFormat(state.selectedBalanceDetails?.amount-state.selectedBalanceDetails?.net_amount)}</div>
            <div className="row">Withdrawal Net Amount (IDR): {NumberFormat(state.selectedBalanceDetails?.net_amount)}</div>
        </div>
    );
}

export default BalanceInquiryDetail;